export class Customer {
    public id: number;
    public customerTypeId: number;

    public updatedBy: string;
    public updatedDate: any;
}
